import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';

import { CustomInputComponent } from '../../../../shared/components/custom-input/custom-input.component';
import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';

export interface BrazilStateOption {
  value: string;
  label: string;
}

@Component({
  selector: 'umkt-inscription-step2',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, CustomInputComponent, I18nPipe],
  templateUrl: './inscription-step2.component.html',
  styleUrls: [
    '../../cadastro-parceiros.component.scss',
    '../../cadastro-parceiros-form.component.scss'
  ]
})
export class InscriptionStep2Component {
  @Input() partnerForm!: FormGroup;
  @Input() brazilStates: BrazilStateOption[] = [];
  @Input() onCepSearchClick!: () => void;
}
